import Pagination from "components/navigation/Pagination";
import NotificationHeader from "components/notification/NotificationHeader";
import NotificationTable from "components/notification/NotificationTable";
import { Box } from "components/ui";
import React from "react";
import { ActivityIndicator } from "react-native";
import { useGetNotificationQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Container from "components/general/Container";
import Section from "components/general/Section";
import { useToken } from "@gluestack-style/react";

type NotificationPageProps = {
	showPagination?: boolean | undefined | null;
	isDashboard?: boolean;
};

export const NotificationPage = ({ showPagination = true, isDashboard = false }: NotificationPageProps) => {
	const [pageNumber, setPageNumber] = React.useState(1);
	const [eventTypeIdCollection, setEventTypeIdCollection] = React.useState<number[]>([]);
	const [siteIdCollection, setSiteIdCollection] = React.useState<number[]>([]);
	const [hasRead, setHasRead] = React.useState<boolean | undefined>(undefined);
	const isMobile = useIsMobile();

	const { data, isLoading, isFetching, isError, error, currentData } = useGetNotificationQuery({
		pageNumber,
		eventTypeIdCollection: eventTypeIdCollection,
		hasRead: hasRead,
		groupIdCollection: siteIdCollection,
	});
	const resolvedNeutral35 = useToken("colors", "neutral35");

	if (isLoading) {
		return (
			<Box minHeight={400} justifyContent="center" alignItems="center" padding={20}>
				<ActivityIndicator size="large" color={"#1A428A"} style={{ transform: [{ scale: 1.5 }] }} />
			</Box>
		);
	}

	if (data == null || data.list == null) {
		return;
	}

	const handleOnEventTypeChange = (newEventTypeIdCollection: number[]) => {
		setEventTypeIdCollection(newEventTypeIdCollection);
	};

	return (
		<Section padding={isDashboard ? 0 : "auto"}>
			<Container sx={{ background: resolvedNeutral35 }}>
				<Box paddingHorizontal={isMobile ? 0 : isDashboard ? 0 : 47}>
					<NotificationHeader isDashboard dataList={data.list} onEventTypeChange={handleOnEventTypeChange} onHasReadChange={setHasRead} onSiteChange={setSiteIdCollection} />
					{isFetching ? (
						<Box minHeight={400} justifyContent="center" alignItems="center" padding={20}>
							<ActivityIndicator size="large" color={"#1A428A"} style={{ transform: [{ scale: 1.5 }] }} />
						</Box>
					) : (
						<>
							{data != null && <NotificationTable dataList={data.list} />}
							<Box justifyContent="center" py={isDashboard ? 12 : 30} alignItems="center">
								{showPagination && <Pagination pageCount={data?.metaData?.pageCount} pageNumber={data?.metaData?.pageNumber} onChangePage={setPageNumber} />}
							</Box>
						</>
					)}
				</Box>
			</Container>
		</Section>
	);
};
